export * from './right-title-content'
